// Small inline line icons (decorative: always aria-hidden; label the parent control).
const base = {
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.6,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  'aria-hidden': true,
  focusable: 'false',
};

const icon = (children) =>
  function Icon({ className = 'h-6 w-6', ...rest }) {
    return (
      <svg {...base} className={className} {...rest}>
        {children}
      </svg>
    );
  };

export const MenuIcon = icon(<path d="M4 7h16M4 12h16M4 17h10" />);
export const CloseIcon = icon(<path d="M6 6l12 12M18 6L6 18" />);
export const SearchIcon = icon(
  <>
    <circle cx="11" cy="11" r="6.5" />
    <path d="m20 20-4.2-4.2" />
  </>
);
export const BagIcon = icon(
  <>
    <path d="M5.5 8.5h13l-1 11.5h-11l-1-11.5Z" />
    <path d="M9 8.5V7a3 3 0 0 1 6 0v1.5" />
  </>
);
export const AlertIcon = icon(
  <>
    <path d="M12 4 3 19.5h18L12 4Z" />
    <path d="M12 10v4M12 17v.01" />
  </>
);
export const ChevronDownIcon = icon(<path d="m6 9 6 6 6-6" />);
export const ChevronLeftIcon = icon(<path d="m15 6-6 6 6 6" />);
export const ChevronRightIcon = icon(<path d="m9 6 6 6-6 6" />);
export const ArrowRightIcon = icon(<path d="M5 12h14m-5-5 5 5-5 5" />);
export const PlusIcon = icon(<path d="M12 5v14M5 12h14" />);
export const MinusIcon = icon(<path d="M5 12h14" />);
export const TrashIcon = icon(
  <>
    <path d="M5 7h14M10 11v6M14 11v6" />
    <path d="M6.5 7l.8 12h9.4l.8-12M9.5 7V5h5v2" />
  </>
);
export const LinkIcon = icon(
  <>
    <path d="M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1 1" />
    <path d="M14 10a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1-1" />
  </>
);
export const ShareIcon = icon(
  <>
    <path d="M12 15V4m0 0L8 8m4-4 4 4" />
    <path d="M6 11v8h12v-8" />
  </>
);
export const TruckIcon = icon(
  <>
    <path d="M3 6h11v10H3zM14 10h4l3 3v3h-7" />
    <circle cx="7" cy="17.5" r="1.5" />
    <circle cx="17" cy="17.5" r="1.5" />
  </>
);
export const CheckIcon = icon(<path d="m5 12.5 4.5 4.5L19 7.5" />);
export const FilterIcon = icon(<path d="M4 7h10M18 7h2M4 17h4M12 17h8M14 4.5v5M8 14.5v5" />);
export const InfoIcon = icon(
  <>
    <circle cx="12" cy="12" r="8.5" />
    <path d="M12 11v5M12 8v.01" />
  </>
);
export const QrIcon = icon(
  <>
    <path d="M4 4h6v6H4zM14 4h6v6h-6zM4 14h6v6H4z" />
    <path d="M14 14h2v2h-2zM18 14h2M14 18v2M18 18h2v2" />
  </>
);
export const WalletIcon = icon(
  <>
    <path d="M4 7.5A2.5 2.5 0 0 1 6.5 5H18v3" />
    <path d="M4 7.5V17a2 2 0 0 0 2 2h13a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1H6.5A2.5 2.5 0 0 1 4 7.5Z" />
    <path d="M16 13.5h.01" />
  </>
);
export const MailIcon = icon(
  <>
    <path d="M4 6h16v12H4z" />
    <path d="m4 7 8 6 8-6" />
  </>
);
export const PinIcon = icon(
  <>
    <path d="M12 21s-6.5-6-6.5-11a6.5 6.5 0 0 1 13 0c0 5-6.5 11-6.5 11Z" />
    <circle cx="12" cy="10" r="2.3" />
  </>
);
export const WhatsAppIcon = ({ className = 'h-6 w-6', ...rest }) => (
  <svg
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden="true"
    focusable="false"
    className={className}
    {...rest}
  >
    <path d="M12.04 2a9.9 9.9 0 0 0-8.5 14.9L2 22l5.25-1.38A9.9 9.9 0 1 0 12.04 2Zm0 1.8a8.1 8.1 0 1 1-4.2 15.03l-.3-.18-3.1.82.83-3.03-.2-.31A8.1 8.1 0 0 1 12.04 3.8Zm-3.1 4.1c-.18 0-.47.07-.72.33-.24.27-.93.9-.93 2.2s.95 2.55 1.08 2.73c.13.18 1.84 2.9 4.5 3.95 2.2.87 2.65.7 3.12.65.48-.04 1.55-.63 1.77-1.24.22-.6.22-1.13.15-1.24-.07-.11-.24-.18-.5-.31-.27-.13-1.55-.77-1.79-.86-.24-.09-.42-.13-.6.13-.17.27-.68.86-.83 1.04-.15.18-.31.2-.57.07-.27-.13-1.12-.41-2.13-1.31-.79-.7-1.32-1.57-1.47-1.83-.16-.27-.02-.41.12-.54.12-.12.27-.31.4-.47.13-.15.18-.27.27-.44.09-.18.04-.33-.02-.47-.07-.13-.6-1.46-.83-2-.2-.48-.4-.5-.6-.5Z" />
  </svg>
);
